import React from 'react';
import styled from 'styled-components';

const Cell = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    font-size: 16px;
    justify-content: flex-start;
    gap: 0.2rem;
    align-items: center;

    & > * {
        min-width: 28px;
        min-height: 28px;
        height: 28px;
        max-height: 28px;
        max-width: 28px;
        padding: 0;

        transition: none;
        border: 1px solid transparent;
        border-radius: 5px;

        // Since these are likely some variety of icon button, attempt to center
        // that icon internally
        display: inline-flex;
        align-items: center;
        justify-content: center;

        --border-color-active: var(--text-primary);
        .action-delete {
            --border-color-active: var(--error-hover);
        }
        .action-navigate {
            --border-color-active: var(--text-link);
        }

        &:disabled {
            background-color: transparent !important;
            border-color: transparent !important;
        }
        &:hover {
            background-color: var(--action-hover);
            border-color: var(--border-default);
        }
        &:active {
            border-color: var(--border-color-active);
        }
    }
`;

export function ActionMenuTableCell({
    className,
    children,
}: React.PropsWithChildren<{ className?: string }>): JSX.Element {
    return <Cell className={className}>{children}</Cell>;
}
